var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.bemBlock },
    [
      _c("BaseFieldText", {
        ref: "searchField",
        attrs: {
          autocomplete: "off",
          bem: "the-search-field",
          "input-type": "search",
          name: "the-search-field",
          label: "Search here",
          placeholder: _vm.$msg("search.input.placeholder", "search")
        },
        on: {
          focus: _vm.focus,
          focusout: function($event) {
            return _vm.delayedFocusout(_vm.focusout)
          },
          keyup: [
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "down", 40, $event.key, [
                  "Down",
                  "ArrowDown"
                ])
              ) {
                return null
              }
              return _vm.focusSuggestion($event)
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.quickSearch()
            }
          ]
        },
        model: {
          value: _vm.value,
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      }),
      _vm._v(" "),
      (_vm.searchAIEnabled && _vm.imageSearchEnabled) || _vm.isTestParticipant
        ? _c("BaseImageSearch", { class: _vm.bemElement("image-search") })
        : _vm._e(),
      _vm._v(" "),
      (_vm.searchAIEnabled || _vm.isTestParticipant) && _vm.value
        ? _c(
            "button",
            {
              class: ["btn", _vm.bemElement("btn-reset")],
              on: { click: _vm.reset }
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$msg("search.input.reset", "search")) +
                  "\n  "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.searchAIEnabled && !_vm.isTestParticipant
        ? _c(
            "button",
            {
              class: [_vm.bemElement("btn-close"), "btn-close"],
              on: {
                click: _vm.hide,
                focus: function() {
                  return (_vm.isCloseBtnFocused = true)
                },
                focusout: function($event) {
                  _vm.delayedFocusout(function() {
                    return (_vm.isCloseBtnFocused = false)
                  })
                }
              }
            },
            [
              _c("span", { staticClass: "visually-hidden" }, [
                _vm._v(_vm._s(_vm.$msg("search.input.reset", "search")))
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "p",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                !_vm.searchAIEnabled &&
                !_vm.isLoadingSearch &&
                _vm.value !== "" &&
                _vm.productsCount === 0 &&
                ((_vm.quickSearchCommitted && !_vm.isFocusWithin) ||
                  (_vm.searchCommitted && !_vm.isFocusWithin)),
              expression:
                "!searchAIEnabled && !isLoadingSearch\n      && value !== ''\n      && productsCount === 0\n      && ((quickSearchCommitted && !isFocusWithin)\n        || (searchCommitted && !isFocusWithin))\n    "
            }
          ],
          class: _vm.bemElement("hero-message"),
          on: { click: _vm.focus }
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$msg("search.heromessage.noresultsfor", "search", [
                  _vm.value
                ])
              ) +
              "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.message !== "",
              expression: "message !== ''"
            }
          ],
          class: _vm.bemElement("message")
        },
        [_vm._v("\n    " + _vm._s(_vm.message) + "\n  ")]
      ),
      _vm._v(" "),
      _vm.shouldShowSuggestions
        ? _c(
            "div",
            {
              class: [
                _vm.bemElement("suggestions-wrapper", {
                  loading:
                    _vm.quickSearchWillBeCommitted && _vm.hasQueryMinLength()
                })
              ]
            },
            [
              _c(
                "ul",
                { class: [_vm.bemElement("suggestions"), "u-scrollbar-none"] },
                _vm._l(_vm.suggestions, function(res, index) {
                  return _c("TheSearchSuggestion", {
                    key: index,
                    ref: "suggestions",
                    refInFor: true,
                    attrs: { match: _vm.value, text: res },
                    on: {
                      focus: function() {
                        return (_vm.isSuggestionFocused = true)
                      },
                      focusout: function($event) {
                        _vm.delayedFocusout(function() {
                          return (_vm.isSuggestionFocused = false)
                        })
                      }
                    },
                    nativeOn: {
                      click: function($event) {
                        $event.preventDefault()
                        return (function() {
                          _vm.suggestionClickHandler(res)
                        })($event)
                      },
                      keyup: [
                        function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return (function() {
                            _vm.suggestionClickHandler(res)
                          })($event)
                        },
                        function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "up", 38, $event.key, [
                              "Up",
                              "ArrowUp"
                            ])
                          ) {
                            return null
                          }
                          return (function() {
                            return _vm.focusSuggestion(index - 1)
                          })($event)
                        },
                        function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "left", 37, $event.key, [
                              "Left",
                              "ArrowLeft"
                            ])
                          ) {
                            return null
                          }
                          if ("button" in $event && $event.button !== 0) {
                            return null
                          }
                          return (function() {
                            return _vm.focusSuggestion(index - 1)
                          })($event)
                        },
                        function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "down", 40, $event.key, [
                              "Down",
                              "ArrowDown"
                            ])
                          ) {
                            return null
                          }
                          return (function() {
                            return _vm.focusSuggestion(index + 1)
                          })($event)
                        },
                        function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "right", 39, $event.key, [
                              "Right",
                              "ArrowRight"
                            ])
                          ) {
                            return null
                          }
                          if ("button" in $event && $event.button !== 2) {
                            return null
                          }
                          return (function() {
                            return _vm.focusSuggestion(index + 1)
                          })($event)
                        }
                      ]
                    }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "spinner-wrapper" },
                [_c("BaseSpinner", { attrs: { inline: "", tiny: "" } })],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }